import React from "react";

type CyberGridProps = {
  animate?: boolean;
  opacity?: number;
  wash?: boolean;
  tone?: "dark" | "light";
  className?: string;
};

export const CyberGrid: React.FC<CyberGridProps> = ({
  animate = false,
  opacity = 0.06,
  wash = true,
  tone = "light",
  className = "",
}) => {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${
        tone === "dark" ? "cyber-grid-tone-dark" : "cyber-grid-tone-light"
      } ${className}`}
      style={{ opacity }}
    >
      <div className="absolute inset-0 cyber-grid-lines" />
      <div className="absolute inset-0 cyber-grid-dots" />

      {/* Micro flow */}
      {animate ? <div className="absolute inset-0 cyber-grid-flow" /> : null}

      {/* Readability wash (light sections only) */}
      {wash ? <div className="absolute inset-0 cyber-grid-wash" /> : null}
    </div>
  );
};
